import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { DataService } from '../../shared/data.service';
import { UtilsService } from '../../shared/utils.service';
import { AlertDialogComponent } from '../../shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    standalone: false
})
export class SignInComponent implements OnInit {
  loginForm!: FormGroup;
  invalidCridentials!: boolean;
  maximumAllowedAttempts!: boolean;

  constructor(public dialog: MatDialog, private dataService: DataService, private authService: AuthService,
              private utils: UtilsService,
              private cookie: CookieService,
              private router: Router) { }

  ngOnInit(): void {
    this.loginForm = new FormGroup({
      password: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.email]),
    });
  }
  openForgetPassword() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(ForgetPasswordComponent, {disableClose: true,});
    dialogRef.afterClosed().subscribe((status) => {
    });
  }

  closeDialog() {
      this.dialog.closeAll();
  }

  onSubmit() {
    const payload = {
      Password: this.loginForm.get('password')?.value,
      Email: this.loginForm.get('email')?.value,
      Platform: 3
    };
    if (this.loginForm.valid) {
      this.dataService.post('auth/Login', payload).then((data) => {
        if (data.statusCode === 200) {
          const currentUser = data.data;
          this.authService.setUserData(currentUser);
          this.utils.saveUserData(currentUser);
          this.invalidCridentials = false;
          this.router.navigate(['/dashboard']);
          this.dialog.closeAll();
          this.creatNotificationToken();
        } else if (data.statusCode === 601) {
          this.maximumAllowedAttempts = false;
          this.invalidCridentials = true;
        }
        else if (data.statusCode === 608) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Banned',
              type: 'Info',
              message: 'User is banned',
              buttonText: 'Ok'
            }
          });
        }
         else if (data.statusCode === 603 ) {
            this.dialog.closeAll();
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Not verified',
                type: 'Warn',
                message: 'Please verify your account using the email we sent you.',
                buttonText: 'Ok'
              }
            });
        } else if (data.statusCode === 620 ) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Not Activated',
              type: 'Warn',
              message: 'This account not activated yet from the admin',
              buttonText: 'Ok'
            }
          });
        } else if (data.statusCode === 621 ) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Expired Subscription',
              type: 'Warn',
              message: 'Your subscription has expired. Please renew your subscription to continue.',
              buttonText: 'Ok'
            }
          });
        } else if (data.statusCode === 618 ) {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'You have exceeded the maximum number of login attempts. Please try again later',
              buttonText: 'Ok'
            }
          });
      }
      else {
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
      });
    }
    else {
      this.loginForm.markAllAsTouched();
    }
  }

  creatNotificationToken() {
    const payload = {
      DeviceId: this.cookie.get('uuid'),
      DeviceInfo: JSON.parse(this.cookie.get('deviceInfo')),
      Platform: 3,
      FirebaseToken: localStorage.getItem('notificationToken')
    };
    this.dataService.post('RegisterDeviceToken', payload).then((data) => {
      if (data.statusCode === 200) {
      }
    });
  }

}
